export default __webpack_public_path__ + "static/media/allocation.a3222468.png";